"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contrast = exports.active = exports.wrapper = exports.container = void 0;

var react_1 = require("@emotion/react");

var constants_1 = require("../../constants");

exports.container = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-right: 16px;\n"])));
exports.wrapper = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: var(--gray-600);\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 20px;\n  letter-spacing: -0.4px;\n  text-align: center;\n  padding: 16px 0px;\n  cursor: pointer;\n  user-select: none;\n  word-break: keep-all;\n\n  @media (min-width: ", "px) {\n    &:hover {\n      color: var(--gray-600);\n      border-bottom: 3px solid var(--blue-400);\n    }\n  }\n"])), constants_1.BREAK_POINT.MOBILE);
exports.active = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: var(--gray-800);\n  border-bottom: 3px solid var(--blue-400);\n\n  &:hover {\n    color: var(--gray-800);\n  }\n"])));
exports.contrast = react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: var(--blue-500);\n\n  &:hover {\n    color: var(--gray-500);\n  }\n"])));